import { SSFCategoryBanner } from "./SSFCategoryBanner";

export default SSFCategoryBanner;
